import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { JobProcedureFormCopilotConfirmation, JobProcedureFormDetailsResponse } from 'src/app/models/procedure-copilot-confirmation-details.model';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import {fadeIn, fadeOut, slideDown, slideUp} from '../../animations';
import { ToastType } from '../toast/models/toast-type.enum';
import { ToastService } from 'src/app/services/ui/toast.service';
import { JobProcedureService } from 'src/app/services/sections/job/job-procedure.service';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import moment from "moment";
import { StepPhotosComponent } from '../procedure-copilot-confirmation/step-photos/step-photos.component';

@Component({
  selector: 'app-procedure-step-form-details',
  templateUrl: './procedure-step-form-details.component.html',
  styleUrls: ['./procedure-step-form-details.component.scss',  '../job-details/job-details.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss'],
  animations: [slideUp(100), slideDown(100), fadeIn(200), fadeOut(200)]
})
export class ProcedureStepFormDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
  public self = this;
  public readonly moment = moment;
  public readonly ButtonIcons = ButtonIcons;

  public routePayload: JobProcedureFormDetailsResponse = {
    stepPhotos: [],
    stepResult: undefined as any
  };
  public procedureName: string = null;

  public isStepResultLoading: boolean = false;
  public isStepPhotosLoading: boolean = false;
  public isLoadingParticipant: boolean = false;

  public participantTabContent: JobProcedureFormCopilotConfirmation[] = [];

  public unsubscriber$ = new Subject<void>();

  public canDisplay: boolean = false;
  private expandedStepIndex: number | null = null;
  public isFromSummaryReview: boolean = false;

  @ViewChild('stepPhotosComponent') private stepPhotosComponent?: StepPhotosComponent;

  public noOp(): void {
    // No operation function for read-only form viewer
  }

  constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private procedureService: JobProcedureService
  ) { 
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
    this.canDisplay = true;
  }
	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
    GlobalSettingsService.navigationBarActions.clear();
	}

  ngOnInit() {

    GlobalSettingsService.navigationBarActions.clear();
    GlobalSettingsService.navigationBarActions.set(
      'close-details-view',
      {
        icon: 'close',
        listOrder: 0,
        text: 'Close',
        isInDropdownMenu: false,
        isTextOnlyShownInDropdown: true,
        action: () => {
          if (this.stepPhotosComponent?.isPhotoModalOpen()) {
            this.stepPhotosComponent.closePhotoModal();
          } else {
            this.onCloseDetailsView();
          }
        }
      }
    );

    this.isFromSummaryReview = this.router.url.includes('procedure-summary-review');
    this.routePayload = this.activatedRoute.snapshot.data.formDetails as JobProcedureFormDetailsResponse || {stepPhotos: [], stepResult: undefined as any};
    this.procedureName = history.state.procedureName || this.routePayload.stepResult.formName;
    this.expandedStepIndex = history.state.expandedStepIndex;
    const jobProcedureFormId = Number(this.activatedRoute.snapshot.paramMap.get('jobProcedureFormId'));
    if (this.isFromSummaryReview && jobProcedureFormId) {
      this.getConfirmationHistoryByFormId(jobProcedureFormId);
    }
  }

  public onNavigationBack(): void {
		this.router.navigate(['../../'], { relativeTo: this.activatedRoute, state:{ expandedStepIndex:this.expandedStepIndex} });
	}

  public onCloseDetailsView(): void {
    if (this.stepPhotosComponent?.isPhotoModalOpen()) {
      this.stepPhotosComponent.closePhotoModal();
      return;
    }

    this.onNavigationBack();
  }

  getConfirmationHistoryByFormId(jobProcedureFormId: number): void {
    this.isLoadingParticipant = true;
    this.procedureService.getSummaryConfirmationHistoryByJobProcedureFormId(TokenHelper.getToken(this.activatedRoute), jobProcedureFormId).subscribe(
      (history: JobProcedureFormCopilotConfirmation[]) => {
        this.participantTabContent = history;
        this.isLoadingParticipant = false;
      },
      (error) => {
        console.error('Error fetching confirmation history', error);
        ToastService.pushToast({
          text: 'Unable to fetch confirmation history. Please try again!',
          icon: 'error',
          type: ToastType.Error
        });
        this.isLoadingParticipant = false;
      }
    );
  }
}
